import type { GameProductShort } from '@patrianna/shared-patrianna-types/store/GameModule'

import { PARLAY_ROOM_CODES_GC, PARLAY_ROOM_CODES_SC } from 'config/parlay-rooms-codes'
import BingoTile from 'containers/Bingo/BingoTile'
import { useAppSelector } from 'store/hooks'
import { getActiveCurrencyIdSelector } from 'store/modules/currencies/selectors'

import useGetBingoProducts from '../hooks/useGetBingoProducts'

type Props = {
  ids?: string
}

export default function BingoRoomsByIdContainer({ ids }: Props) {
  const bingoGames = useGetBingoProducts()
  const activeCurrency = useAppSelector(getActiveCurrencyIdSelector)
  const currencyRoomCodes = activeCurrency === 'SC' ? PARLAY_ROOM_CODES_SC : PARLAY_ROOM_CODES_GC

  if (!ids?.trim()) {
    return null
  }

  const codes = ids.split(',').map((code) => code.trim())
  const rooms = bingoGames.filter(
    (item: GameProductShort) => codes.includes(item.code) && currencyRoomCodes.includes(item.code),
  )

  if (rooms.length === 0) {
    return null
  }

  return (
    <div className='grid items-start gap-3 px-4 pb-4 grid-cols-2 lg:grid-cols-3' data-testid='bingo-rooms-container'>
      {rooms.map((room) => (
        <BingoTile key={room.code} room={room} with3DImage hideFavorite />
      ))}
    </div>
  )
}
